module.exports = __webpack_public_path__ + "static/media/DeliverOptimized.74813205.jp2";